import React from "react";
import { Route, Switch } from "react-router-dom";
import Loadable from 'react-loadable';

import CircularProgress from "components/CircularProgress";
import Error404 from "../../components/ErrorPages/Error404";

const Dashboard = Loadable({
  loader: () => import('../../containers/Mis/Dashboard'),
  loading: CircularProgress,
});
const Worklist = Loadable({
  loader: () => import('../../containers/Mis/Worklist'),
  loading: CircularProgress,
});
const SubmittedForVerification = Loadable({
  loader: () => import('../../containers/Mis/SubmittedForVerification'),
  loading: CircularProgress,
});
const Parked = Loadable({
  loader: () => import('../../containers/Mis/Parked'),
  loading: CircularProgress,
});
const Verified = Loadable({
  loader: () => import('../../containers/Mis/Verified'),
  loading: CircularProgress,
});
const SubmittedToTypist = Loadable({
  loader: () => import('../../containers/Mis/SubmittedToTypist'),
  loading: CircularProgress,
});
const ReportViewer = Loadable({
  loader: () => import('../../containers/Mis/ReportViewer'),
  loading: CircularProgress,
});

const PrivateTemplates = Loadable({
  loader: () => import('../../containers/Templates/index'),
  loading: CircularProgress,
});

const PrivateDiagrams = Loadable({
  loader: () => import('../../containers/Diagrams/index'),
  loading: CircularProgress,
});

const WorklistVisits = Loadable({
  loader: () => import('../../containers/WorklistVisits/index'),
  loading: CircularProgress,
});

// const TypistHistoryReports = Loadable({
//   loader: () => import('../../containers/Mis/TypistHistoryReports/index'),
//   loading: CircularProgress,
// });
const Library = Loadable({
  loader: () => import('../../containers/Library/Dashboard'),
  loading: CircularProgress,
});
const MyLibrary = Loadable({
  loader: () => import('../../containers/Library/MyLibrary/index'),
  loading: CircularProgress,
});
const AllCases = Loadable({
  loader: () => import('../../containers/Library/AllCases/index'),
  loading: CircularProgress,
});
const NewCases = Loadable({
  loader: () => import('../../containers/Library/NewCases/index'),
  loading: CircularProgress,
});

const Mis = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/dashboard`} component={Dashboard} />
    <Route exact path={`${match.url}/worklist`} component={Worklist} />
    <Route exact path={`${match.url}/submitted-for-verification`} component={SubmittedForVerification} />
    <Route exact path={`${match.url}/parked`} component={Parked} />
    <Route exact path={`${match.url}/verified`} component={Verified} />
    <Route exact path={`${match.url}/submitted-to-typist`} component={SubmittedToTypist} />
    <Route exact path={`${match.url}/report-viewer`} component={ReportViewer} />
    <Route exact path={`${match.url}/private-templates`} component={PrivateTemplates} />
    <Route exact path={`${match.url}/private-diagram`} component={PrivateDiagrams} />
    <Route exact path={`${match.url}/worklist-visits`} component={WorklistVisits} />
    {/* <Route exact path={`${match.url}/typist-history-reports`} component={TypistHistoryReports} /> */}
    <Route exact path={`${match.url}/library`} component={Library} />
    <Route exact path={`${match.url}/my-library`} component={MyLibrary} />
    <Route exact path={`${match.url}/all-cases`} component={AllCases} />
    <Route exact path={`${match.url}/new-cases`} component={NewCases} />
    <Route component={() => <Error404 redirectTo="/mis/dashboard" />} />
  </Switch>
);

export default Mis;
